module.exports = __webpack_public_path__ + "img/FCST-ability-01.98d42fd2.png";